export default {
  breadcrumb: {
    home: 'Home',
    catalog: 'Catalog',
  },
  loading: 'Loading…',
  notFound: 'Not found',
  addedToCartToast: '{name} added to cart',
  region: {
    global: 'Global',
  },
  price: {
    label: 'Price',
  },
  availability: {
    inStock: 'In stock — instant delivery',
    soldOut: 'Sold out',
    noLongerAvailable: 'No longer available',
  },
  delisted: 'This listing has been delisted by the supplier and can no longer be purchased. Browse the catalog for alternatives.',
  actions: {
    addToCart: 'Add to cart',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    share: 'Share',
    viewCart: 'Added — view cart →',
    cartLimit: 'Cart limit reached ({limit} per transaction)',
  },
  trust: {
    instantDelivery: 'Instant key delivery',
    keyStorage: '24-hour in-app key storage',
    eurPricing: 'EUR pricing',
  },
  offers: {
    heading: 'Offers from other sellers',
    count: '{count} offer | {count} offers',
    lowestLabel: 'lowest {price}',
    lowest: 'Lowest',
    anonymous: 'Anonymous merchant',
    inStock: '{qty} in stock',
    addToCart: 'Add to cart',
  },
  about: {
    heading: 'About this product',
    showMore: 'Show more',
    showLess: 'Show less',
    noDescription: 'No description available for this title.',
  },
  meta: {
    releaseDate: 'Release date',
    developer: 'Developer',
    publisher: 'Publisher',
    languages: 'Languages',
    genre: 'Genre',
    playerMode: 'Player mode',
    playerModeSingle: 'Single-player',
    activationRegion: 'Activation region',
    languagesCount: '{langs} + {more} more',
  },
  included: {
    heading: "What's included",
    keyLine: '{name} ({platform} key)',
    accountLine: '{name} ({platform} account)',
    languages: 'Subtitles & UI in {count}+ languages',
    permanent: 'Permanent activation — no subscription required',
    defaultPlatform: 'PC',
  },
  activation: {
    heading: 'How to activate your key',
    steam: [
      'Launch the Steam client software and log into your account.',
      'Click the "Games" menu at the top of the client.',
      'Choose "Activate a Product on Steam..."',
      'Follow the onscreen instructions to complete the process.',
    ],
    gog: [
      'Open the GOG GALAXY client or visit gog.com and log into your account.',
      'Click on your username in the top-right corner.',
      'Choose "Redeem a code" from the dropdown menu.',
      'Enter your key and follow the prompts to add the game to your library.',
    ],
    epic: [
      'Launch the Epic Games Launcher and log in.',
      'Click your account name in the top-right and open Account.',
      'Find the "Redeem Code" option in the menu.',
      'Paste your key and confirm to add the game to your library.',
    ],
    ea: [
      'Launch the EA app and sign in to your EA account.',
      'Open the menu and choose "Redeem product code".',
      'Enter your activation key in the dialog.',
      'Confirm to add the title to your EA library.',
    ],
    xbox: [
      'Open the Microsoft Store or Xbox app and sign in.',
      'Open your profile menu in the top-right corner.',
      'Select "Redeem code" from the menu.',
      'Enter the 25-character code and confirm.',
    ],
    account: [
      'Open your order and reveal the account login details.',
      'Sign in to the platform client with those details.',
      'Follow any instructions the seller included with the account.',
      'Download the game from the account library.',
    ],
    generic: [
      'Open your order and reveal your code.',
      'Go to the platform or website named in the product title and sign in.',
      'Find the option to redeem or activate a code.',
      'Enter the code and follow the onscreen instructions.',
    ],
  },
  related: {
    heading: 'You might also like',
    viewAll: 'View all',
  },
};
